import Title from "./Title";

export default function ContextSection() {
    return (
        <section className="py-10 sm:py-16">
            <Title
                title={"Het project"}
                subtitle={"Samenwerking tussen de studie Creative Media & Gaming Technologies x Nederlandse Publieke Omroep"}
            />
            <div className="max-w-6xl container w-full mx-auto grid md:grid-cols-2 gap-16">
                <div className="flex flex-col space-y-8 place-self-end">
                    <p className="text-lg"> Als opdracht voor het vak Medialab 1 van de Hogeschool Rotterdam zijn wij in opdracht van de NPO dit project gestart. Het doel van dit project is om een concept te bedenken om jongeren te bereiken met content waarin publieke waarden vertegenwoordigd zijn.  Hierin krijgen wij 8 weken de tijd om een concept te bedenken en uit te werken als een prototype.
                    </p>
                    <p className="text-base">
                        Op deze website kunt u meer informatie vinden over ons project, de concepten die wij hebben bedacht, deelproducten en het uiteindelijke prototype van het verkozen concept.
                    </p>

                </div>
                <dl className="flex flex-col space-y-6">

                    <div className="flex flex-col-reverse">
                        <dt className="text-gray-500">De hoofdvraag van het project</dt>
                        <dd className="font-bold text-xl mb-2"> Hoe bereiken wij het beste jongeren met content waarin publieke waarden vertegenwoordigd zijn? </dd>

                    </div>
                    <div className="flex flex-col-reverse">
                        <dt className="text-gray-500"> Het thema van ons project </dt>
                        <dd className="font-bold text-xl mb-2"> Nieuw publiek (be)trekken en vasthouden </dd>

                    </div>
                    <div className="flex flex-col-reverse">
                        <dt className="text-gray-500"> De doelgroep </dt>
                        <dd className="font-bold text-lg lg:text-xl mb-2">Jongeren 16 - 24 jaar </dd>

                    </div>
                </dl>
            </div>
        </section>
    );
}